import * as moment from 'moment';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
var CipComponent = /** @class */ (function () {
    function CipComponent(_formService) {
        this._formService = _formService;
        this.rows = [];
        this.matcher = new FormService();
        this.maxDate = moment().toDate();
        this.form = new FormGroup({
            certcip: new FormControl('', Validators.required),
            fecha_cip: new FormControl({ value: '', disabled: true }, Validators.required)
        });
        if (!JSON.parse(localStorage.getItem("cip"))) {
            localStorage.setItem("cip", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("cip"));
            //this.form.controls['fecha_cip'].setValue(this.rows[0] ? new Date(moment(this.rows[0].fecha_cip, "DD/MM/YYYY").toDate()) : null)
            this.form.controls['fecha_cip'].setValue(this.rows[0] ? moment(this.rows[0].fecha_cip, "DD/MM/YYYY").toDate() : null);
            this.form.controls['certcip'].setValue(this.rows[0] ? this.rows[0].certcip : '');
        }
    }
    CipComponent.prototype.add_cip = function (event, type) {
        if (event) {
            this.fecha_cip = moment(event.value).format('DD/MM/YYYY');
        }
        else {
            var temp = JSON.parse(localStorage.getItem("cip"));
            if (temp[0]) {
                this.fecha_cip = temp[0].fecha_cip;
            }
            else {
                this.fecha_cip = '';
            }
        }
        localStorage.setItem("cip", JSON.stringify([]));
        this.actualRow = localStorage.getItem("cip");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            certcip: this.form.value.certcip,
            fecha_cip: this.fecha_cip
        });
        localStorage.setItem("cip", JSON.stringify(this.rows));
        //this.form.reset();
        //this.cip = JSON.parse(localStorage.getItem("cip"));
    };
    CipComponent.prototype.delete_cip = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("cip", JSON.stringify(this.rows));
            }
        }
    };
    return CipComponent;
}());
export { CipComponent };
